import Emittery from 'emittery'

export const eventEmitter = new Emittery()
